import * as React from 'react';
import {connect} from 'react-redux';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as POIModule from 'Modules/POIModule';
import * as AOIModule from 'Modules/AOIModule';
import * as UserModule from 'Modules/UserModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as NotificationModule from 'Modules/NotificationModule';
import * as HistoryModule from 'Modules/HistoryModule';
import * as FleetModule from 'Modules/FleetModule';
import * as MapModule from 'Modules/MapModule';
import * as AlertModule from 'Modules/AlertModule';
import * as Dictionary from 'Models/Dictionary';
import {EnumTypes as PageEnumTypes} from 'Models/EnumTypes/PageEnumTypes';
import {Map, TileLayer} from 'react-leaflet';
import * as L from 'leaflet';
import {
  CarMarkerList,
  mapBounds,
  mapOptions,
  maxZoom,
  minZoom,
  NotificationMarker,
  osmURL,
  PoiMarkerList
} from './MapHelpers/MapHelpers';
import {AddPOI, AddPOITool} from './MapHelpers/AddPoi';
import AddZone from './MapHelpers/AddZone';
import AoiZones from './MapHelpers/AoiZones';
import ToggleAddingZonesBtn from './MapHelpers/ToggleAddingZonesBtn';
import SummaryMapManagement from './MapHelpers/SummaryMapManagement';
import ZoomManagement from './MapHelpers/ZoomManagement';
import HistoryRides from './History/HistoryRides';
import {SummaryAlertsRender} from './CarDetails/Composites/Alerts';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {getPOIByLatLon} from '../../Connectors/POIConnector';
import {CarDetailsViewType} from "Models/EnumTypes/HistoryEnumTypes";
import MapTimerManager from "components/Map/MapHelpers/MapTimer.Manager";
import MapSearchManager from "./MapHelpers/MapSearch.Manager";
import {combineClasses} from "components/Layout/Search/Search.Component";

export type State = {
  popupPosition: {
    lat: number;
    lng: number;
  };
  currentAddress: any;
  addPoiFormVisible: boolean;
  newZoneLatLng: Array<L.LatLngExpression>;
};
export type ConnectedProps = {
  vehiclesStore: VehiclesModule.Types.VehiclesStore;
  poiStore: POIModule.Types.POIStore;
  userStore: UserModule.Types.UserStore;
  historyStore: HistoryModule.Types.HistoryStore;
  viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
  aoiStore: AOIModule.Types.AOIStore;
  alertStore: AlertModule.Types.AlertStore;
  mapStore: MapModule.Types.MapStore;
  activeNotification: NotificationModule.Types.NotificationDto;
  hasSearched: boolean
};
export type DispatchedProps = {
  showLoader: Function;
  setVehicleDetailsPage: Function;
  getPOIList: Function;
  addPoi: Function;
  setActivePoi: Function;
  showPoiDetails: Function;
  hidePoiDetails: Function;
  togglePoiDetails: Function;
  getTodaysCarRides: Function;
  setActiveRideViewType: Function;
  addCoordsToNewZone: Function;
  deleteAoi: Function;
  getSingleCarDetails: Function;
  setMapCenter: Function;
  getAoiList: () => Function;
  setMapZoom: Function;
  showAddingPOI: () => void;
  getUsersFleet: Function;
  hideAddingPOI: () => void;
  addPoiPopupPosition: (popupPosition: { lat: number; lng: number }) => void;
  clearActiveNotification: () => void;
  setCarDetailsView: () => void;
  deletePoi: (poiID: number) => void;
  updatePoi: (poiData: POIModule.Types.UpdatePointOfinterestRequest, poiID: number) => void;
  showPopup: (popupData: ViewManagementModule.Types.Popup) => void;
  hideVehicleList: () => void;
  initSearchedVehicles: () => void;
};
export type Props = {
  match: any;
};

class Mapz extends React.Component<Props & DispatchedProps & ConnectedProps, State> {
  private mapRef: L.Map;
  private componentMapRef: any;

  constructor(props: Props & DispatchedProps & ConnectedProps) {
    super(props);
    this.state = {
      popupPosition: {
        lat: null,
        lng: null
      },
      currentAddress: null,
      addPoiFormVisible: false,
      newZoneLatLng: []
    };
    this.vehicleClick = this.vehicleClick.bind(this);
    this.onMapClickPOI = this.onMapClickPOI.bind(this);
    this.addPOI = this.addPOI.bind(this);
    this.updatePOI = this.updatePOI.bind(this);
    this.poiMarkerClick = this.poiMarkerClick.bind(this);
    this.handleRef = this.handleRef.bind(this);

    this.resetPoiDialogs();

    // Niektóre ekrany posiadające liste samochodów z jakiegoś powodu wywołują pokazanie tej listy mimo tego, że
    // jest ona na całym widoku i z tego powodu przez wejściem na widok przestawiam na ukrytą listę
    if (
      !this.props.vehiclesStore.queryParams?.get('search')
      && this.props.match.path === Dictionary.PageUrl.get(PageEnumTypes.Page.MAP)
      && this.props.viewManagementStore.vehicleListVisible
    ) {
      this.props.hideVehicleList()
    }

    this.props.initSearchedVehicles()
  }

  public async componentDidMount() {
    if (this.props.match.path === Dictionary.PageUrl.get(PageEnumTypes.Page.MAP)) {
      return
    }
    await this.props.getPOIList();
    await this.props.getAoiList();
  }

  public componentDidUpdate(prevProps: Readonly<Props & DispatchedProps & ConnectedProps>): void {
    if (this.props.match.path !== prevProps.match.path) {
      this.resetPoiDialogs();
    }
  }

  public async vehicleClick(vehicle: VehiclesModule.Types.CarDto) {
    const {activeVehicleDetails, singleCarViewData} = this.props.vehiclesStore;
    const {setMapCenter} = this.props;
    if (vehicle.latestDataframe) {
      await setMapCenter({lat: vehicle.latestDataframe.latitude, lng: vehicle.latestDataframe.longitude});
    }

    // Dodałem sprawdzenie ze stora singleCarViewData bo on jest odczytywany w CarDetails zaś activeVehicleDetails
    // jest przestawiany na liście wszystkich aut po kliknięciu w wiersz co powodowało błąd z brakiem możliwości
    // wybrania skopiowanego samochodu
    if (!activeVehicleDetails || activeVehicleDetails.id !== vehicle.id || singleCarViewData.car.id !== vehicle.id) {
      this.props.setVehicleDetailsPage(vehicle);
      this.props.clearActiveNotification();
      this.props.setCarDetailsView();
      await this.props.getSingleCarDetails(vehicle.id);
      await this.props.setActiveRideViewType(HistoryModule.EnumTypes.RideViewType.TODAYS);
      await this.props.getTodaysCarRides(vehicle.id);
    }
  }

  public render() {
    const {
      vehiclesStore: {vehiclesListFiltered, vehiclesList},
      match,
      viewManagementStore,
      mapStore,
      setMapZoom,
      setMapCenter,
      poiStore,
      alertStore,
      activeNotification,
      historyStore,
      hasSearched
    } = this.props;
    const {popupPosition} = this.state;
    const {AOI, POI} = HistoryModule.EnumTypes.ZonesViewType;

    let vehiclesListToShow = vehiclesListFiltered.results.length > 0 ? vehiclesListFiltered.results : vehiclesList || [];

    if (match.path === Dictionary.PageUrl.get(PageEnumTypes.Page.MAP)) {
      vehiclesListToShow = vehiclesListFiltered.results
    }

    return (
      <div className="main__content main__content--no-padding">
        {(viewManagementStore.activeAddingPOI) && (
          <AddPOITool
            onClose={() => {
              this.props.hidePoiDetails();
              this.props.hideAddingPOI();
            }}
            currentAddress={this.state.currentAddress}
            onSubmit={this.addPOI}
          />
        )}
        {poiStore.poiDetailsPopupVisible && (
          <AddPOITool
            onClose={() => {
              this.props.hidePoiDetails();
              this.props.setActivePoi(null);
            }}
            onDelete={this.deletePOi}
            editable
            initialValues={poiStore.activePoi}
            onSubmit={this.updatePOI}
          />
        )}
        <Map
          center={mapStore.center}
          zoom={mapStore.zoom}
          onClick={event => this.onMapClickPOI(event)}
          options={mapOptions}
          onZoomEnd={zoomObj => {
            setMapZoom(zoomObj.target._zoom);
          }}
          maxZoom={maxZoom}
          minZoom={minZoom}
          zoomControl={false}
          maxBounds={mapBounds}
          bounds={this.getRideBounds()}
          id='mainMap'
          ref={this.handleRef}
          // onViewportChanged={viewport => setMapCenter({lat: viewport.center[0], lng: viewport.center[1] })}
        >
          <TileLayer url={osmURL}/>
          {match.path === Dictionary.PageUrl.get(PageEnumTypes.Page.MAP) && (
            <>
              {viewManagementStore.summaryMapView.car && <HistoryRides />}
              {viewManagementStore.summaryMapView.car &&
                <CarMarkerList carsList={vehiclesListToShow} onClick={this.vehicleClick}
                               mapCurrentZoom={mapStore.zoom}/>}
              {viewManagementStore.summaryMapView.poi &&
                <PoiMarkerList onClick={this.poiMarkerClick} mapCurrentZoom={mapStore.zoom}/>}
              {viewManagementStore.summaryMapView.aoi && <AoiZones/>}
              {viewManagementStore.summaryMapView.alert &&
                <SummaryAlertsRender alertHistoryLog={alertStore.alertHistoryLog}/>}
              {activeNotification && <NotificationMarker notification={activeNotification}/>}
            </>
          )}
          {match.path === Dictionary.PageUrl.get(PageEnumTypes.Page.ZONES) && (
            <>
              {viewManagementStore.activeZoneView === HistoryModule.EnumTypes.ZonesViewType.POI && (
                <>
                  <PoiMarkerList onClick={this.poiMarkerClick} mapCurrentZoom={mapStore.zoom}/>
                  {viewManagementStore.activeAddingPOI && (
                    <AddPOI
                      popupPosition={poiStore.addPoiPopupPosition}
                      onClose={() => {
                        this.props.hideAddingPOI();
                        this.setState({popupPosition: null});
                      }}
                      currentAddress={this.state.currentAddress}
                      onSubmit={this.addPOI}
                    />
                  )}
                </>
              )}
              {viewManagementStore.activeZoneView === HistoryModule.EnumTypes.ZonesViewType.AOI && (
                <>
                  <AoiZones/>
                  <AddZone/>
                </>
              )}
              {(viewManagementStore.activeZoneView === AOI || viewManagementStore.activeZoneView === POI) && (
                <ToggleAddingZonesBtn
                  addingActive={viewManagementStore.activeZoneView === AOI ? viewManagementStore.activeAddingAOI : viewManagementStore.activeAddingPOI}
                  zoneActive={viewManagementStore.activeZoneView}
                />
              )}
            </>
          )}
        </Map>


        {match.path === Dictionary.PageUrl.get(PageEnumTypes.Page.MAP) && (
          <div className={combineClasses("map-manage", !hasSearched && "map-manage--blurred")}>
            <MapSearchManager/>
            <SummaryMapManagement/>
            <ZoomManagement/>
            <MapTimerManager />
          </div>
        )}
      </div>
    );
  }

  private resetPoiDialogs() {
    this.props.hideAddingPOI();
    this.props.hidePoiDetails();
  }

  private onMapClickPOI(event: any) {
    const {path} = this.props.match;
    const {lat, lng} = event.latlng;
    const {viewManagementStore, addCoordsToNewZone} = this.props;
    const pageURLPOI = Dictionary.PageUrl.get(PageEnumTypes.Page.ZONES);
    if (path === pageURLPOI && viewManagementStore.activeZoneView === HistoryModule.EnumTypes.ZonesViewType.POI && viewManagementStore.activeAddingPOI) {
      this.props.hidePoiDetails();
      this.props.hideAddingPOI();
      this.props.addPoiPopupPosition({lat, lng});
      this.setState({popupPosition: {lat, lng}});
      getPOIByLatLon(lat, lng).then(results => {
        const address = results.data.addressDisplayName;
        this.setState({
          currentAddress: address
        });
      });
      this.props.showAddingPOI();
    }
    if (viewManagementStore.activeZoneView === HistoryModule.EnumTypes.ZonesViewType.AOI && viewManagementStore.activeAddingAOI) {
      addCoordsToNewZone([lat, lng]);
    }
  }

  private async addPOI(formData: POIModule.Types.AddPointOfInterestRequest) {
    formData.authorUserId = this.props.userStore.user.id;
    formData.latitude = this.state.popupPosition.lat;
    formData.longitude = this.state.popupPosition.lng;
    await this.props.addPoi(formData);
    this.setState({
      addPoiFormVisible: false
    });
  }

  private poiMarkerClick(el: POIModule.Types.PointOfInterestDto) {
    this.props.setActivePoi(el);
    this.props.hidePoiDetails();
    this.props.showPoiDetails();
    this.props.setMapZoom(9);
    this.props.setMapCenter({lat: el.latitude, lng: el.longitude});
    this.setState({addPoiFormVisible: false});
  }

  private async updatePOI(data: POIModule.Types.PointOfInterestDto) {
    const {title, address, latitude, longitude, radiusMeters} = data;
    const poiData: POIModule.Types.UpdatePointOfinterestRequest = {
      title,
      address,
      latitude,
      longitude,
      radiusMeters
    };
    await this.props.updatePoi(poiData, this.props.poiStore.activePoi.id);
    this.setState({
      addPoiFormVisible: false
    });
  };

  private deletePOi = async () => {
    const {PopupType} = ViewManagementModule.VMEnumTypes;
    this.props.showPopup({
      type: PopupType.DELETE_POI,
      confirmCallback: async () => {
        await this.props.deletePoi(this.props.poiStore.activePoi.id);
        this.props.hidePoiDetails();
      }
    });
  };

  private handleRef(ref: any) {
    if (ref) {
      this.componentMapRef = ref;
      this.mapRef = ref.leafletElement;
    }
  }

  private getRideBounds() {

    if (this.props.viewManagementStore.activeCarDetailsView === CarDetailsViewType.CAR_DETAILS) {
      return null;
    } else if (this.props.viewManagementStore.activeCarDetailsView === CarDetailsViewType.HISTORY_RIDES) {
      switch (this.props.viewManagementStore.activeRideView) {
        case HistoryModule.EnumTypes.RideViewType.DETAILS:
          return this.props.historyStore.currentSingleRideBoundsCentroid.bounds;
        default:
          return this.props.historyStore.currentFullRideBoundsCentroid.bounds;
      }
    }
  }
}

function mapStateToProps(state: RootState): ConnectedProps {
  return {
    vehiclesStore: state.vehiclesStore,
    poiStore: state.poiStore,
    aoiStore: state.aoiStore,
    alertStore: state.alertStore,
    userStore: state.userStore,
    historyStore: state.historyStore,
    viewManagementStore: state.viewManagementStore,
    mapStore: state.mapStore,
    activeNotification: state.notificationStore.activeNotification,
    hasSearched: state.vehiclesStore.hasSearched

  };
}

function mapDispachToProps(dispatch: any): DispatchedProps {
  return {
    setVehicleDetailsPage: (vehicle: VehiclesModule.Types.CarDto) => dispatch(VehiclesModule.Actions.setDetailsForVehile(
      vehicle)),
    getSingleCarDetails: (carId: number) => dispatch(VehiclesModule.Actions.getSingleCarDetails(carId, true)),
    showAddingPOI: () => dispatch(ViewManagementModule.Actions.showAddingPOI()),
    hideAddingPOI: () => dispatch(ViewManagementModule.Actions.hideAddingPOI()),
    showLoader: () => dispatch(ViewManagementModule.Actions.showLoader()),
    getPOIList: () => dispatch(POIModule.Actions.getPoiList()),
    addPoi: (poiDetails: POIModule.Types.AddPointOfInterestRequest) => dispatch(POIModule.Actions.addPoi(poiDetails)),
    setActivePoi: (poiDetails: POIModule.Types.PointOfInterestDto) => dispatch(POIModule.Actions.setDetailsForPoiView(
      poiDetails)),
    showPoiDetails: () => dispatch(POIModule.Actions.showPoiDetailsPopup()),
    hidePoiDetails: () => dispatch(POIModule.Actions.hidePoiDetailsPopup()),
    togglePoiDetails: () => dispatch(POIModule.Actions.togglePoiDetailsPopup()),
    getTodaysCarRides: (carId: number) => dispatch(HistoryModule.Actions.getTodaysCarRide(carId)),
    setActiveRideViewType: (activeRideViewType: HistoryModule.EnumTypes.RideViewType) => dispatch(ViewManagementModule.Actions.SetActiveRideViewType(
      activeRideViewType)),
    addCoordsToNewZone: (coords: L.LatLngExpression) => dispatch(AOIModule.Actions.addCoordsToNewZone(coords)),
    deleteAoi: (aoiId: number) => dispatch(AOIModule.Actions.deleteAoi(aoiId)),
    setMapCenter: (center: MapModule.Types.MapCenter) => dispatch(MapModule.Actions.setMapCenter(center)),
    setMapZoom: (zoom: number) => dispatch(MapModule.Actions.setMapZoom(zoom)),
    getAoiList: () => dispatch(AOIModule.Actions.getAoiList(null)),
    getUsersFleet: () => dispatch(FleetModule.Actions.getUsersFleet()),
    addPoiPopupPosition: (popupPosition: {
      lat: number;
      lng: number
    }) => dispatch(POIModule.Actions.addPoiPopupPosition(popupPosition)),
    clearActiveNotification: () => dispatch(NotificationModule.Actions.setActiveNotification(null)),
    setCarDetailsView: () => dispatch(ViewManagementModule.Actions.setActiveCarDetailsView(HistoryModule.EnumTypes.CarDetailsViewType.CAR_DETAILS)),
    deletePoi: (poiID: number) => dispatch(POIModule.Actions.deletePoi(poiID)),
    showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(
      popupData)),
    updatePoi: (poiData: POIModule.Types.UpdatePointOfinterestRequest,
      poiID: number) => dispatch(POIModule.Actions.updatePoi(poiData, poiID)),
    hideVehicleList: () => dispatch(ViewManagementModule.Actions.hideVehicleList()),
    initSearchedVehicles: () => dispatch(VehiclesModule.Actions.initSearchedVehicles())
  };
}

export default connect(
  mapStateToProps,
  mapDispachToProps
)(Mapz) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/components/Map/_Map.tsx